<div class="dropdown-table-select">
    <div class="search-and-button">
        <i class="icon fa fa-search"></i>
        <input class="search-box" type="search" ng-blur="$ctrl.onBlur()" ng-change="$ctrl.searchTextChanged()" ng-model="$ctrl.searchText" ng-keydown="$ctrl.onKeyDown($event)" ng-focus="$ctrl.onFocus()"/>
        <button type="button" class="results-button" ng-click="$ctrl.actionShowDropdown()"><i class="fa fa-angle-down"></i></button>
    </div>
    <div class="results" ng-show="$ctrl.visible">
        <table>
            <tbody ng-if="$ctrl.tableItems.length === 0">
                <tr>
                    <td colspan="{{$ctrl.table.length}}">{{$ctrl.status}}<div class="add" ng-if="$ctrl.addLink" ng-click="$ctrl.selectItem(null)">{{$ctrl.addLink|translate}}</div></td>
                </tr>
            </tbody>
            <thead ng-if="!$ctrl.hideHeaders">
                <tr>
                    <th ng-repeat="hdr in $ctrl.table track by $index">{{$ctrl.translateHeader(hdr)}}</th>
                </tr>
            </thead>
            <tbody>
                <tr ng-repeat-start="item in $ctrl.tableItems track by $index" ng-click="$ctrl.selectItem(item)" class="top" ng-class="{selected: $ctrl.selectedItem === item, choosen: item.choosen}">
                    <td ng-repeat="hdr in $ctrl.table track by $index" title="{{item.tooltip}}">{{item[hdr]}}</td>
                </tr>
                <tr ng-repeat-end class="bottom" ng-class="{selected: $ctrl.selectedItem === item, choosen: item.choosen}">
                    <td colspan="{{$ctrl.table.length}}" ng-if="item.info">
                        <div class="additional-info">{{item.info}}</div>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</div>